//FL
const F1 = "rgb(255, 0, 0)";
const F3 = "rgb(255, 150, 150)";
const F5 = "rgb(100,0,0)";

//FR
const F2 = "rgb(255, 255, 0)";
const F4 = "rgb(255, 255, 150)";
const F6 = "rgb(100, 100, 0)";

//RL
const R1 = "rgb(0, 255, 0)";
const R3 = "rgb(150, 255, 150)";
const R5 = "rgb(0, 100, 0)";

//RR
const R2 = "rgb(0, 0, 255)";
const R4 = "rgb(150, 150, 255)";
const R6 = "rgb(0, 0, 125)";

export const frontColours = [F1, F2, F3, F4, F5, F6];
export const rearColours = [R1, R2, R3, R4, R5, R6];
